/**
 * 회원가입 약관동의 (/m/signup/agreement) — 가입방식 고르기·약관 보기·동의
 * ($j.Pages.Mobile.SignupAgreement / body data-page-name="SignupAgreement")
 */
export default class SignupAgreement {
    initialize() {
        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        // 가입방식 S:소셜, N:일반, C:기업, M:머큐리 — S·M 은 서버가 정해서 넘긴다
        let joinType = D.type;
        const fixedType = !!joinType;
        const checked = { service: false, privacy: false };
        // 광고성 정보 수신(화면 라벨 「광고·혜택 소식 받기」) — 매체별. 행 = 셋 전부, 매체 칸 = 하나씩
        const AD_CH = ['sms', 'push'];   // AdConsentService::CHANNELS 와 같은 순서 (이메일은 묻지 않는다)
        const ad = { sms: false, push: false };
        const NEXT_URL = { N: '/m/auth?type=join', S: '/m/auth?type=social', C: '/m/signup/sosok', M: '/m/signup/sosok' };
        const TERM_TITLES = { terms: '서비스 이용약관', privacy: '개인정보 수집·이용 동의', adterm: '광고성 정보 수신 동의' };   // 화면 라벨은 「광고·혜택 소식 받기」, 전문 제목은 법적 명칭
        // 동의 항목 ↔ 약관 전문 태그(/m/ajax/modal/term)
        const TERM_TAG = { service: 'terms', privacy: 'privacy', ad: 'adterm' };
        let busy = false;

        // 광고 수신 동의는 모든 유형에게 묻는다(기업회원 포함 — 2026-11). 작업사진 활용 동의는 가입 때 받지 않는다 — 수발주자 전환 시트가 묻는다
        const asksAd = () => true;
        const keys = () => ['service', 'privacy'];

        $(function () {
            if (fixedType) $('#sg-types').prop('hidden', true);

            $('#sg-types').on('click', '.sg-type', function () {
                joinType = this.dataset.value;
                if (!asksAd()) AD_CH.forEach((c) => { ad[c] = false; });
                render();
            });

            // 광고 매체 칸 — 바로 켜고 끈다
            $('#sg-ad-subs').on('click', '.sg-sub', function () {
                const ch = this.dataset.ch;
                ad[ch] = !ad[ch];
                render();
            });

            $('#sg-terms')
                .on('click', '.sg-view', function (e) {
                    e.stopPropagation();   // 행 체크로 번지지 않게 — › 는 전문만 연다
                    const key = $(this).closest('.sg-check').data('key');
                    openTerm(this.dataset.tag, () => {
                        if (key === 'ad') AD_CH.forEach((c) => { ad[c] = true; });
                        else checked[key] = true;
                        render();
                    });
                })
                .on('click', '.sg-check', function () {
                    toggle(this.dataset.key);
                })
                .on('keydown', '.sg-check', function (e) {
                    if (e.target !== this) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggle(this.dataset.key);
                    }
                });

            $('#next-button').on('click', agree);

            // 뒤로가기로 페이지가 캐시 복원되면 전송중 표시가 남아 버튼이 먹통이 된다
            window.addEventListener('pageshow', function (e) {
                if (e.persisted) busy = false;
            });

            render();
        });

        /** 전체 동의가 켜진 상태인가 — 필수 둘과 광고 매체가 전부 켜져 있을 때 */
        function allOn() {
            return keys().every((k) => checked[k]) && (!asksAd() || AD_CH.every((c) => ad[c]));
        }
        function setAll(on) {
            keys().forEach((k) => { checked[k] = on; });
            AD_CH.forEach((c) => { ad[c] = asksAd() && on; });
        }

        /**
         * 체크는 바로 켜고 끈다. 전문은 › 로 언제든 읽을 수 있고, 거기서 [동의합니다]를 눌러도 켜진다.
         * (위치정보 동의 시트는 끝까지 읽어야 켜지는 규칙을 그대로 둔다 — F/Mobile/LocationGate)
         * 'all' = 전체 동의 — 다 켜져 있으면 전부 끄고, 아니면 전부 켠다. 'ad' = 광고 행 — 매체 셋을 한 번에.
         */
        function toggle(key) {
            if (key === 'all') { setAll(!allOn()); render(); return; }
            if (key === 'ad') {
                const on = !AD_CH.every((c) => ad[c]);
                AD_CH.forEach((c) => { ad[c] = on; });
                render();
                return;
            }
            checked[key] = !checked[key];
            render();
        }

        function render() {
            const mk = asksAd();

            $('#sg-row-ad').prop('hidden', !mk);
            $('#sg-ad-subs').prop('hidden', !mk);
            $('#sg-ad-subs .sg-sub').each(function () {
                const on = !!ad[this.dataset.ch];
                this.classList.toggle('is-on', on);
                this.setAttribute('aria-pressed', on ? 'true' : 'false');
            });

            $('#sg-terms .sg-check').each(function () {
                const key = this.dataset.key;
                const on = key === 'all' ? allOn() : key === 'ad' ? AD_CH.every((c) => ad[c]) : !!checked[key];
                this.classList.toggle('is-on', on);
                this.setAttribute('aria-checked', on ? 'true' : 'false');
            });

            $('#sg-types .sg-type').each(function () {
                this.setAttribute('aria-checked', this.dataset.value === joinType ? 'true' : 'false');
            });

            // 버튼을 감추지 않고, 왜 못 누르는지 버튼 위 한 줄로 알려준다
            const ready = !!joinType && checked.service && checked.privacy;
            $('#next-button').prop('disabled', !ready);
            $('#sg-hint').text(ready ? '' : (!joinType ? '회원 유형을 선택해 주세요.' : '필수 약관에 동의해 주세요.'));
        }

        function agree() {
            if (busy || $('#next-button').prop('disabled') || !NEXT_URL[joinType]) return;
            busy = true;

            $.ajax({
                url: '/m/ajax/signup/agree',
                type: 'post',
                dataType: 'json',
                data: {
                    ad_asked: asksAd() ? 1 : 0,   // 광고 수신을 물었는가 (안 물은 동의는 기록하지 않는다)
                    ad_sms: asksAd() && ad.sms ? 1 : 0,
                    ad_push: asksAd() && ad.push ? 1 : 0,
                },
            })
                .done(function (res) {
                    if (res && res.result) {
                        location.replace(NEXT_URL[joinType]);
                        return;
                    }
                    busy = false;
                    $j.Common.Util.swalert('약관 동의를 저장하지 못했습니다. 다시 시도해 주세요.');
                })
                .fail(function () {
                    busy = false;
                    $j.Common.Util.swalert('네트워크 오류로 진행하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                });
        }

        /**
         * 약관 전문 뷰어 — 끝까지 스크롤해야 하단 [동의합니다]가 열린다(F/Mobile/LocationGate._openTerm 과 같은 모양·동작).
         * 다 읽기 전 버튼은 '끝까지 읽어주세요 ↓' 이고, 누르면 본문을 맨 아래로 내려준다.
         * disabled 를 쓰면 클릭이 안 와서 내려줄 수 없다 — 잠금은 .is-locked 로 한다.
         */
        function openTerm(tag, onAgree) {
            const modal = $j.Ui.Modal.open({
                mode: 'full',
                panelClass: 'lc-doc-modal',
                title: TERM_TITLES[tag] || '약관',
                html: '<div class="lc-doc">불러오는 중…</div>',
            });
            const $body = modal.el.find('.ui-modal__body');
            const $foot = $('<div class="lc-doc-foot"><button type="button" class="lc-doc-agree is-locked">끝까지 읽어주세요 <span aria-hidden="true">↓</span></button></div>');
            $body.after($foot);
            const $agree = $foot.find('.lc-doc-agree');
            let loaded = false;   // 불러오는 중에는 짧아서 바닥이다 — 그때 열리면 안 된다
            let ro = null;
            const tryEnable = () => {
                const el = $body[0];
                if (!loaded || el.scrollHeight - el.scrollTop - el.clientHeight > 8) return false;
                $agree.removeClass('is-locked').text('동의합니다');
                if (ro) { ro.disconnect(); ro = null; }
                return true;
            };
            $body.on('scroll', tryEnable);
            $agree.on('click', function () {
                if ($agree.hasClass('is-locked')) {
                    if (!loaded) return;
                    const el = $body[0];
                    const top = el.scrollHeight - el.clientHeight;
                    try { el.scrollTo({ top, behavior: 'smooth' }); } catch (e) { el.scrollTop = top; }
                    setTimeout(tryEnable, 400);
                    setTimeout(tryEnable, 900);
                    return;
                }
                modal.close();
                if (onAgree) onAgree();
            });

            $.post('/m/ajax/modal/term', { tag })
                .done(function (html) {
                    modal.setBody('<div class="lc-doc">' + (html || '내용이 없습니다.') + '</div>');
                    loaded = true;
                    if (tryEnable()) return;
                    // 웹뷰는 모달 높이가 늦게 잡혀 즉시 판정이 이르다 — 크기가 정해질 때 다시 본다
                    if (window.ResizeObserver) { ro = new ResizeObserver(tryEnable); ro.observe($body[0]); }
                    setTimeout(tryEnable, 200);
                    setTimeout(tryEnable, 600);
                })
                .fail(function () { modal.setBody('<div class="lc-doc">약관을 불러오지 못했습니다.</div>'); });
        }
    }
}
